import { Tabs as TabsLib, styled } from "@mui/material";
import { COLORS } from "constants/layout";

const PaidTabs = styled(TabsLib)(({ theme }) => ({
  minHeight: 42,
  backgroundColor: COLORS.green[400],
  ".MuiButtonBase-root": {
    padding: "8px 16px",
    textTransform: "initial",
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "25px",
    color: "#fff",
    minHeight: 42,
  },
  ".MuiButtonBase-root.Mui-selected, .MuiButtonBase-root.Mui-selected:hover": {
    color: COLORS.green[700],
    backgroundColor: COLORS.green[25],
  },
  ".MuiButtonBase-root:hover": {},
  ".MuiTabs-indicator": {
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    minHeight: 32,
    ".MuiButtonBase-root": {
      padding: "8px",
      minHeight: 32,
      lineHeight: "16px",
      fontSize: 12,
    },
  },
}));

export default PaidTabs;
